import { render, staticRenderFns } from "./checkout.vue?vue&type=template&id=2ab51980&scoped=true&"
import script from "./checkout.vue?vue&type=script&lang=js&"
export * from "./checkout.vue?vue&type=script&lang=js&"
import style0 from "./checkout.vue?vue&type=style&index=0&id=2ab51980&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab51980",
  null
  
)

export default component.exports